<script lang="ts" setup>
import RadioButton, {
  type RadioButtonEmits,
  type RadioButtonProps,
  type RadioButtonSlots,
} from 'primevue/RadioButton'

interface Props extends /* @vue-ignore */ RadioButtonProps {
  error?: boolean
}
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface Emits extends /* @vue-ignore */ RadioButtonEmits {}
withDefaults(defineProps<Props>(), { binary: true })
defineEmits<Emits>()

const model = defineModel<Props['modelValue'] | null>()

const errorInjected = inject<Ref<boolean>>('error', ref(false))

const slots = defineSlots<RadioButtonSlots>()
</script>

<template>
  <RadioButton
    v-bind="$props"
    v-model="model"
    :invalid="errorInjected || error"
  >
    <template
      v-for="(_, slot) in slots"
      #[slot]="slotData"
    >
      <slot
        :name="slot"
        v-bind="slotData"
      />
    </template>
  </RadioButton>
</template>
